<template>
    <v-dialog v-model="getModalCadastroMarca" max-width="500px" transition="dialog-transition">
        <v-card outlined>
            <v-card-title>Cadastro de Marca</v-card-title>
            <v-form class="px-3" ref="form">
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-text-field dense outlined v-model="getMarca.marca" label="Marca" class="ml-2 mr-2" :rules="rules.marca" @keyup.13="salvar"></v-text-field>	
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-btn outlined color="default" @click="setModalCadastroMarca(false)">Voltar</v-btn>
                    <v-btn outlined color="error" @click="excluirMarca(getMarca.id)" v-if="getMarca.id">Excluir</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn outlined color="success" @click="salvar">Salvar</v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
    import {mapActions, mapGetters} from 'vuex'
    export default {
        data(){
            return {
                rules: {
                    marca : [
                        v => !!v || 'Campo obrigatório'
                    ]
                }
            }
        },
        computed: {
            ...mapGetters([
            'getMarca',
            'getModalCadastroMarca'
            ])
        },
        methods: {
            ...mapActions([
            'atualizarMarca',
            'salvarMarca',
            'excluirMarca',
            'setModalCadastroMarca'
            ]),
            salvar(){
                if(this.$refs.form.validate()){
                    if(this.getMarca.id){
                        this.atualizarMarca(this.getMarca)
                    }else{
                        this.salvarMarca(this.getMarca)
                    }
                }
            }
        },
    }
</script>